import { create } from "zustand";
import {
  getAllListApi,
  getItemNearToExpiryDiscountApi,
  getItemNearToExpiryDiscountApibydivision,
  getListAfterApproveApi,
  getListForApproveApi,
  getNearToExpiryDiscountByIdApi,
  getScanApi,
  postItemNearToExpiryDiscountApi,
} from "../services/nearToExpiry";

export const useNearToExpiryStore = create((set) => ({
  expiryDiscountList: [],
  expiryAllList: [],
  expiryScanList: [],
  expiryListApprove: [],
  expiryListAfterApprove: [],
  expiryDiscount: null,

  setLoading: (value) => set({ loading: value }),
  // Actions
  getExpiryDiscount: async (payload) => {
    set({ loading: true });
    try {
      const response = await getItemNearToExpiryDiscountApibydivision(payload);
      const formattedData = response?.Data.map((element, index) => ({
        ...element,
        serialNo: index + 1,
      }));
      set({ expiryDiscountList: formattedData || [] });
    } catch (error) {
      console.error("Error fetching IRN list:", error);
      set({ expiryDiscountList: [] });
    } finally {
      set({ loading: false });
    }
  },
  addExpiryDiscount: async (payload) => {
    set({ loading: true });
    try {
      const response = await postItemNearToExpiryDiscountApi(payload);
      //   set({ category: response?.Data || [] });
      return response?.data;
    } catch (error) {
      console.error("Error fetching IRN list:", error);
      //   set({ category: [] });
    } finally {
      set({ loading: false });
    }
  },
  getExpiryDiscountById: async (id) => {
    try {
      const response = await getNearToExpiryDiscountByIdApi(id);
      set({ expiryDiscount: response?.Data });
    } catch (error) {
      console.error("Error fetching IRN list:", error);
    }
  },

  getAllList: async (loaction, division, date) => {
    set({ loading: true });
    try {
      const response = await getAllListApi(loaction, division, date);
      const formattedData = response?.Data.map((element, index) => ({
        ...element,
        serialNo: index + 1,
      }));

      set({ expiryAllList: formattedData || [] });
    } catch (error) {
      console.error("Error fetching IRN list:", error);
      set({ expiryAllList: [] });
    } finally {
      set({ loading: false });
    }
  },
  getScanList: async (payload) => {
    set({ loading: true });
    try {
      const response = await getScanApi(payload);

      set({ expiryScanList: response?.Data || [] });
    } catch (error) {
      console.error("Error fetching IRN list:", error);
      set({ expiryAllList: [] });
    } finally {
      set({ loading: false });
    }
  },
  getListForApprove: async (payload) => {
    set({ loading: true });
    try {
      const response = await getListForApproveApi(payload);

      set({ expiryListApprove: response?.Data || [] });
    } catch (error) {
      console.error("Error fetching IRN list:", error);
      set({ expiryListApprove: [] });
    } finally {
      set({ loading: false });
    }
  },
  getListAfterApprove: async (payload) => {
    set({ loading: true });
    try {
      const response = await getListAfterApproveApi(payload);
      const formattedData = response?.Data.map((element, index) => ({
        ...element,
        serialNo: index + 1,
      }));

      set({ expiryListAfterApprove: formattedData || [] });
    } catch (error) {
      console.error("Error fetching IRN list:", error);
      set({ expiryListAfterApprove: [] });
    } finally {
      set({ loading: false });
    }
  },
}));
